import React from 'react';
import { useTranslation } from 'react-i18next';
import omit from 'lodash/omit';
import type { TGetTransportsRes } from 'api/swagger';
import { useUpdateTransport } from 'api/transports/use-update-transport';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { FormDrawerWithButton, EFormDrawerWithButtonIconType } from 'components/common/form-drawer-with-button';
import { TransportForm } from 'components/transport/transport-form';
import type { ITransportFormFields } from 'components/transport/transport-form';

interface ITransportUpdateDrawerComponentProps {
  transport: TGetTransportsRes;
}

const TransportUpdateComponent: React.FC<ITransportUpdateDrawerComponentProps> = (props) => {
  const { transport } = props;

  const { t } = useTranslation();

  const { mutateAsync: updateTransport, isLoading } = useUpdateTransport(transport.id);

  const handleFinish = async (values: ITransportFormFields) => {
    const apiVariables = {
      ...omit(values, ['subcontractor']),
      subcontractorId: values.subcontractor?.value ?? null,
      defaultCostPerKm: values.defaultCostPerKm,
    };

    await updateTransport(apiVariables);
  };

  const initialValues: ITransportFormFields = {
    plateNumber: transport.plateNumber,
    subcontractor: {
      value: transport.subcontractor?.id,
      label: transport.subcontractor?.shortName || transport.subcontractor?.name,
    },
    type: transport.type,
    maxLDM: transport.maxLDM,
    maxVolume: transport.maxVolume,
    maxWeight: transport.maxWeight,
    needService: transport.needService,
    inService: transport.inService,
    serviceComment: transport.serviceComment,
    subType: transport.subType,
    notUsed: transport.notUsed,
    defaultCostPerKm: transport.defaultCostPerKm ?? undefined,
  };

  return (
    <FormDrawerWithButton
      formComponent={TransportForm}
      formProps={{ initialValues, isEditMode: true }}
      title={t('transport:update_transport')}
      isLoading={isLoading}
      iconType={EFormDrawerWithButtonIconType.EDIT}
      buttonType='text'
      onFinish={handleFinish}
    />
  );
};

export const TransportUpdate = withRoleGuard<ITransportUpdateDrawerComponentProps>(TransportUpdateComponent, [
  UserRole.admin,
  UserRole.mechanic,
]);
